import { atom } from 'recoil';

export const hasNotificationAtom = atom<boolean>({
  key: 'hasNotification',
  default: false,
});
